export const routeNames = {
  LANDING: "/",
  ASKLOCATION: "/ask-location",
  VENUES: "/venues",
  SUCCESS: "/success",
  SCAN: "/scan/:id",
  WINNER: "/winner",
  NOT_WINNER: "/not-winner",
  ALREADY_ENTERED: "/already-entered",
  OUTHOURS: "/out-of-hours",
  PREENTRY: "/pre-entry",
  CLOSED: "/closed",
  TERMS: "/terms",
  COOKIES: "/cookie-policy",
  PRIVACY: "/privacy-policy",
  SHARE: "/share/:id",
};
